import { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';
import styles from './Knowledge.module.scss';
import { Layout } from 'features/Layouts/Layouts';

export const Knowledge = () => {
  const knowledgeDivRef = useRef<HTMLDivElement>(null);

  const token = localStorage.getItem('token');

  useEffect(() => {
    const rootElement = knowledgeDivRef.current;
    if (rootElement) {
      if (token) {
        rootElement.setAttribute(
          'token',
          `Bearer 2340|ojdRvO9go4FfJe22jZfFi6HRNNQM2266Ji9ErkFg`,
        );
      } else {
        rootElement.removeAttribute('token');
      }
    }

    const link = document.createElement('link');
    link.href = process.env.REACT_APP_URL_KB_CSS!;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    document.head.appendChild(link);

    const script = document.createElement('script');
    script.src = process.env.REACT_APP_URL_KB!;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      if (script.parentNode) {
        document.body.removeChild(script);
      }
      if (link.parentNode) {
        document.head.removeChild(link);
      }
    };
  }, [token]);

  return (
    <Layout>
      <Helmet>
        <title>База знаний</title>
      </Helmet>
      <div
        id='root_knowledge'
        role='lk'
        ref={knowledgeDivRef}
        className={styles.knowledgeRoot}
      />
    </Layout>
  );
};
